import { ThunkAction } from 'redux-thunk';
import AppState from '../../types/AppState';
import { RentalFormActionTypes } from './types';
import service from '../../api/service';
import { ROOT_URL } from '../../api';
import { UPDATE_RENTAL_FORM_V2_SUCCESS } from '../../constants/redux';
import deepSnakeCaseKeys from '../deepSnakeCaseKeys';

export const fetchPricing = (
  cancelToken: any = null
): ThunkAction<
  Promise<void>,
  AppState,
  unknown,
  RentalFormActionTypes
> => async (dispatch, getState) => {
  const rentalVersion = getState().rentalFormV2;
  const response = await service.post(
    `${ROOT_URL}/rental_versions/${rentalVersion.id}/calculate_pricing`,
    {
      rental_version: deepSnakeCaseKeys({
        ...rentalVersion.data,
        pricing: null,
      }),
      rental_id: rentalVersion.rentalId,
    },
    {
      cancelToken,
    }
  );

  dispatch({
    type: UPDATE_RENTAL_FORM_V2_SUCCESS,
    payload: response.data,
  });
};
